import { Injectable, IPromise, IQService } from "angular";

import { FeatureToggleService } from "@gtmhub/featureToggle";
import { IGtmhubRootScopeService } from "./models";
import { StateService } from "@uirouter/angularjs";

export const featureToggleEnabled = (featureKey: string): Injectable<(...args: unknown[]) => IPromise<void>> => [
  "$q",
  "FeatureToggleService",
  "$state",
  ($q: IQService, featureToggleService: FeatureToggleService, $state: StateService): IPromise<void> => {
    return featureToggleService.isFeatureAvailable(featureKey).then((enabled) => {
      if (!enabled) {
        $state.go("default");
        return $q.reject(`feature ${featureKey} is not enabled`);
      }
    });
  },
];

export const featureAvailable = (feature: string): Injectable<(...args: unknown[]) => IPromise<void>> => [
  "$q",
  "$rootScope",
  ($q: IQService, $rootScope: IGtmhubRootScopeService): IPromise<void> => {
    return $rootScope.featureAvailable(feature) ? $q.resolve() : $q.reject(`feature ${feature} not available`);
  },
];
